export const SELECT_WRAPPER_ID = (type: string): string => `${type}-select-dropdown`
